(function () {
  'use strict';

  var INDEX_URL = document.currentScript && document.currentScript.dataset.indexUrl;
  if (!INDEX_URL) return;

  // Inject badge styles (care-guide.liquid CSS isn't loaded on collection pages)
  var style = document.createElement('style');
  style.textContent = [
    '.ema-level-badge{display:inline-flex !important;align-items:center;gap:5px;padding:4px 11px;border-radius:20px;font-size:13px !important;font-weight:600 !important;letter-spacing:0.02em;border:1px solid;}',
    '.ema-level-badge::before{content:"Care level:";font-weight:400 !important;opacity:0.7;font-size:0.92em;}',
    '.ema-level-badge--beginner{background:#f0fdf4 !important;color:#166534 !important;border-color:#bbf7d0 !important;}',
    '.ema-level-badge--intermediate{background:#eff6ff !important;color:#1e40af !important;border-color:#bfdbfe !important;}',
    '.ema-level-badge--expert{background:#faf5ff !important;color:#6b21a8 !important;border-color:#e9d5ff !important;}',
    '.ema-card-level-badge{margin:4px 0 6px;min-height:0;}'
  ].join('');
  document.head.appendChild(style);

  var LEVEL_LABELS  = { beginner: 'Beginner', intermediate: 'Intermediate', expert: 'Expert' };
  var LEVEL_CLASSES = { beginner: 'beginner', intermediate: 'intermediate', expert: 'expert' };

  // Populated once the index is fetched
  var handleMap = null;

  function buildMap(index) {
    handleMap = {};
    index.forEach(function (p) {
      if (p.h && p.lv && p.l && p.l !== 'all') handleMap[p.h] = p.l;
    });
  }

  function stampCard(card) {
    if (!handleMap) return;
    var handle = card.dataset.handle;
    var level  = handle && handleMap[handle];
    var slot   = card.querySelector('.ema-card-level-badge');
    if (!level || !slot || slot.hasChildNodes()) return;

    var badge = document.createElement('span');
    badge.className = 'ema-level-badge ema-level-badge--' + (LEVEL_CLASSES[level] || level);
    badge.textContent = LEVEL_LABELS[level] || (level.charAt(0).toUpperCase() + level.slice(1));
    slot.appendChild(badge);
  }

  function stampAll() {
    document.querySelectorAll('product-card[data-handle]').forEach(stampCard);
  }

  function run() {
    fetch(INDEX_URL)
      .then(function (r) { return r.json(); })
      .then(function (index) {
        buildMap(index);
        stampAll();

        // Watch for cards injected later (infinite scroll / AJAX pagination)
        if (window.MutationObserver) {
          var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
              m.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                // The node itself might be a product-card
                if (node.matches && node.matches('product-card[data-handle]')) {
                  stampCard(node);
                }
                // Or it might contain product-cards
                if (node.querySelectorAll) {
                  node.querySelectorAll('product-card[data-handle]').forEach(stampCard);
                }
              });
            });
          });
          observer.observe(document.body, { childList: true, subtree: true });
        }
      })
      .catch(function () { /* silently ignore */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
